<crowdctrl-unauthenticated-page pageTitle="Access Denied" [showFooter]="false" defaultHref="/login">
  <div style="text-align: center; padding: 2rem">
    <h1>Access Denied</h1>
    <p>You do not have permission to access this application.</p>
    <p style="color: var(--ion-color-medium); margin-top: 1rem">
      Please contact your administrator if you believe this is an error.
    </p>
    <ion-button (click)="goToLogin()" fill="solid" color="primary" style="margin-top: 2rem">
      Return to Login
      <ion-icon name="chevron-forward" slot="end"></ion-icon>
    </ion-button>
  </div>
</crowdctrl-unauthenticated-page>
